import store from '../Store';
import { selectAccessories } from '../Store/entities/accessories/hooks';
import { captureSentryError } from '../psUtil';

function accessoriesRow({ worksheet, workbook, row, accessoryItem, quote, userMultiplier, hidePrice, currencyData }) {
	const accessoryPricingObject = quote.accessories.find((acc) =>
		acc
	&& parseInt(acc.accessory_id, 10) === parseInt(accessoryItem.accessory_id, 10));

	const quoteAcc = accessoryItem;

	const state = store.getState();

	const accessorries = selectAccessories(quote.id)(state);

	const accessory = accessorries.find((acc) => acc.part_number === quoteAcc.part_number);

	let col = 1;

	const currencyStyle = workbook.createStyle({

		numberFormat: '$#,##0.00; ($#,##0.00); -',
		fill: {
			type: 'pattern',
			patternType: 'solid',
			fgColor: '#f0f0f0',
		},
		border: {
			left: {
				style: 'thin',
				color: 'black'
			},
			right: {
				style: 'thin',
				color: 'black'
			},
			top: {
				style: 'thin',
				color: 'black'
			},
			bottom: {
				style: 'thin',
				color: 'black'
			},
			diagonal: {
				style: 'thin',
				color: 'black'
			},
			diagonalDown: true,
			outline: true
		}
	});

	const createCell = (string) => {
		const cell = worksheet.cell(row, col++)
			.string(`${string}`)
			.style({
				alignment: {
					horizontal: 'center',
				},
				fill: {
					type: 'pattern',
					patternType: 'solid',
					fgColor: '#f0f0f0',
				},
				border: {
					left: {
						style: 'thin',
						color: 'black'
					},
					right: {
						style: 'thin',
						color: 'black'
					},
					top: {
						style: 'thin',
						color: 'black'
					},
					bottom: {
						style: 'thin',
						color: 'black'
					},
					diagonal: {
						style: 'thin',
						color: 'black'
					},
					diagonalDown: true,
					outline: true
				}
			});
        
		return cell;
	};

	const moneyCell = (amount) => {
		const value = amount || 0;

		worksheet
			.cell(row, col++)
			.number(value)
			.style(currencyStyle);
		
		return createCell;
	};

	createCell(quoteAcc.quantity);

	const accName = accessory?.name || quoteAcc?.name || '';

	createCell(accName);
	createCell(accessory?.part_number ?? quoteAcc?.part_number ?? "");
	
	if (!hidePrice) {
		const accessoryMsrp = accessoryPricingObject?.msrp ?? 0;
		if (
			accessoryMsrp <= 0
			|| !currencyData?.multiplier
			|| !userMultiplier?.multiplier?.multiplier
			|| accessoryPricingObject?.quantity === undefined
			|| accessoryPricingObject?.quantity <= 0
		) {
			console.error({ accessory, accessory_pricing_object: accessoryPricingObject });
			captureSentryError(new Error(`Accessory ${accName} has no Price`));
			createCell(`${currencyData.ISO}0.00 (Something went wrong fetching pricing)`);
			createCell(`${currencyData.ISO}0.00 (Something went wrong fetching pricing)`);
			createCell(`${currencyData.ISO}0.00 (Something went wrong fetching pricing)`);
			createCell(`${currencyData.ISO}0.00 (Something went wrong fetching pricing)`);
			return;
		}
		const accessoryMsrpWithQty = accessoryMsrp * currencyData.multiplier;
		const realMultiplier = userMultiplier.multiplier.multiplier;
		moneyCell((accessoryMsrpWithQty / accessoryPricingObject.quantity));
		moneyCell(accessoryMsrpWithQty);
		moneyCell((accessoryMsrpWithQty / accessoryPricingObject.quantity) * realMultiplier);
		moneyCell((accessoryMsrpWithQty) * realMultiplier);
	}
}

function accessoriesHeaderRow({ worksheet, style, row, hidePrice, currencyData }) {
	let col = 1;

	function cell(string) {
		worksheet.cell(row, col++)
			.string(string)
			.style(style);
	}

	cell(`Qty`);
	cell(`Name`);
	cell(`Part #`);

	if (!hidePrice) {
		cell(`Price (${currencyData.ISO})`);
		cell(`Total Price (${currencyData.ISO})`);
		cell(`Dealer Price (${currencyData.ISO})`);
		cell(`Total Dealer Price (${currencyData.ISO})`);
	}
}

export default function ({ workbook, worksheet, quote, quoteData, userMultiplier, row, hidePrice, currencyData }) {
	let currentRow = row;
	const HEAD_ROW_STYLE = workbook.createStyle({
		alignment: {
			horizontal: 'center',
		},
		fill: {
			type: 'pattern',
			patternType: 'solid',
			fgColor: '#d5d5d5',
		},
		border: {
			left: {
				style: 'thin',
				color: 'black'
			},
			right: {
				style: 'thin',
				color: 'black'
			},
			top: {
				style: 'thin',
				color: 'black'
			},
			bottom: {
				style: 'thin',
				color: 'black'
			},
			diagonal: {
				style: 'thin',
				color: 'black'
			},
			diagonalDown: true,
			outline: true
		}
	});

	const HEADER_STYLE = workbook.createStyle({

		font: {
			size: 16,
			bold: true,
		}
	});

	worksheet
		.cell(currentRow++, 1)
		.string('Accessories')
		.style(HEADER_STYLE);

	accessoriesHeaderRow({
		worksheet, style: HEAD_ROW_STYLE, row: currentRow++, hidePrice, currencyData
	});

	quote.accessories?.forEach((accessory) => accessoriesRow({
		worksheet, workbook, accessoryItem: accessory, quote, userMultiplier, row: currentRow++, hidePrice, currencyData
	}));
	
	currentRow += (quote.accessories || []).length;

	return currentRow;
}
